(($) => {
  $(() => {
    /* Handle login state(s) in localStorage. **********************/

    const localStorageKey = 'loggedIn';

    const login = () => {
      localStorage.setItem(localStorageKey, true);
    };

    const isLoggedIn = () => {
      return localStorage.getItem(localStorageKey);
    };

    const logout = () => {
      localStorage.removeItem(localStorageKey);
    };

    const redirectToHome = () => {
      document.location.href = '/';
    };

    /* Handle HCP Login Form submission. ***************************/

    const $hcpLoginForm = $('.section--hcp-login-form form');

    if ($hcpLoginForm.length) {
      const redirectForm = () => {
        document.location.href = $hcpLoginForm.attr('action');
      };

      if (isLoggedIn() && !Shopify.designMode) {
        redirectForm();
      } else {
        const $fieldset = $hcpLoginForm.children('fieldset');
        const $alert = $hcpLoginForm.find('.alert');

        const showAlert = (message) => {
          $alert.empty().text(message).parent().removeClass('d-none');
        };

        const hideAlert = () => {
          $alert.parent().addClass('d-none');
        };

        $hcpLoginForm.on('submit', (e) => {
          e.preventDefault();

          const formFields = $hcpLoginForm.serializeArray();
          const postData = {};

          formFields.forEach(({ name, value }) => {
            postData[name] = value;
          });

          $fieldset.prop('disabled', true);

          $.ajax({
            url: '/apps/icetray/hcp_auth_login',
            type: 'POST',
            data: postData,
            error(jqXHR, textStatus, errorThrown) {
              const error =
                typeof jqXHR.responseJSON === 'object' && typeof jqXHR.responseJSON.error !== 'undefined'
                  ? jqXHR.responseJSON.error.toString()
                  : errorThrown;

              showAlert(error);

              $fieldset.prop('disabled', false);
            },
            success() {
              login();
              redirectForm();
            },
          });
        });
      }
    }

    /* Handle gated templates depending on login status. ***********/

    const $loggedInTemplate = $('.logged-in-template');

    if ($loggedInTemplate.length) {
      if (isLoggedIn() || Shopify.designMode) {
        $loggedInTemplate.removeClass('d-none');
      } else {
        redirectToHome();
      }
    }

    /* Handle menu items depending on login status. ****************/

    const $registerLoginLinks = $('.register-login-link');
    const $logoutLinks = $('.logout-link');

    if (!isLoggedIn()) {
      $registerLoginLinks.removeClass('d-none');
    } else {
      $logoutLinks.removeClass('d-none').on('click', 'a', () => {
        logout();
        redirectToHome();
      });
    }
  });
})(jQuery);
